import { type SVGProps } from "react";
import type { CartesianGridProps } from "recharts";
import { CHART_RIGHT_MARGIN_PX } from "../../utilities/analyticsHelpers";

type HorizontalGridLineProps = Omit<
  SVGProps<SVGLineElement>,
  "offset" | "strokeDasharray"
> & {
  strokeDasharray?: CartesianGridProps["strokeDasharray"];
  offset: unknown;
  xAxis?: unknown;
  yAxis?: unknown;
  index?: number;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};
export function HorizontalGridLine({
  x1,
  y1,
  x2,
  y2,
  strokeDasharray,
  offset: _offset,
  xAxis: _xAxis,
  yAxis: _yAxis,
  index: _index,
  ...svgProps
}: HorizontalGridLineProps) {
  return (
    <line
      {...svgProps}
      strokeDasharray={strokeDasharray?.toString()}
      x1={x1}
      y1={y1}
      x2={x2 + CHART_RIGHT_MARGIN_PX}
      y2={y2}
      fill="none"
    />
  );
}

type FullHeightCursorProps = SVGProps<SVGLineElement> & {
  points?: { x: number; y: number }[];
  top?: number;
  height?: number;
  bottom?: number;
  // Recharts passes these, but they are not SVG attributes.
  payload?: unknown;
  payloadIndex?: unknown;
  left?: number;
  right?: number;
  width?: number;
  brushBottom?: number;
};

export function FullHeightTooltipCursor({
  points,
  top = 0,
  height = 0,
  bottom = 0,
  payload: _payload,
  payloadIndex: _payloadIndex,
  left: _left,
  right: _right,
  width: _width,
  brushBottom: _brushBottom,
  ...svgProps
}: FullHeightCursorProps) {
  const x = points?.[0]?.x;
  if (x === undefined) return null;

  return (
    <line
      {...svgProps}
      x1={x}
      x2={x}
      y1={0}
      y2={top + height + bottom}
      fill="none"
    />
  );
}
